import { tv } from 'tailwind-variants';
const deleteAccount = tv(
  {
    slots: {
      deleteWrapper: [
        'deleteAccountCTA',
        'w-full',
        'justify-between',
        'py-desk-global-spacing-spacing-6',
        'border-b-[1px]',
        'border-color-border-mid',
        'gap-desk-space-between-tight-horizontal',
      ],
      deleteHeading: [
        'text-heading-desk-small-bold',
        'font-heading-desk-small-bold',
        'leading-heading-desk-small-bold',
      ],
      deleteDescription: [
        'text-body-large-regular',
        'font-body-large-regular',
        'leading-body-large-regular',
      ],
      deleteInfo: ['flex-col'],
      deleteIconAndCTAWrapper: ['item-start', 'gap-1', 'h-fit', 'cursor-pointer'],
      icon: ['h-[20px]'],
      deleteCTA: [
        'h-fit',
        'text-system-red',
        'text-body-large-bold_underline',
        'font-body-large-bold_underline',
        'leading-body-large-bold_underline',
        'underline',
      ],
      popUpWrapper: ['flex-col', 'gap-desk-space-between-tight-vertical'],
      popUpWidth: [
        'max-w-[995px]',
        'pl-mob-padding-base-x',
        'max-w-[995px]',
        'pl-mob-padding-base-x',
      ],
      popUpTitle: [
        'font-heading-desk-large-bold',
        'text-heading-desk-large-bold',
        'leading-heading-desk-large-bold',
      ],
      popUpDescription: [
        'font-body-large-regular',
        'text-body-large-regular',
        'leading-body-large-regular',
      ],
      popUpCTAWrapper: ['gap-[8px]', 'align-start'],
      popUpCTAs: ['w-full'],
      gotItCTA: [''],
    },
    compoundSlots: [
      {
        slots: [
          'deleteInfo',
          'deleteWrapper',
          'deleteIconAndCTAWrapper',
          'popUpWrapper',
          'popUpCTAWrapper',
        ],
        className: 'flex',
      },
    ],
    variants: {
      size: {
        mobile: {
          deleteWrapper: ['pr-mob-margin-base-right', 'mb-mob-padding-tight-y'],
          popUpCTAs: ['!px-0'],
          deleteInfo: ['gap-mob-margin-tight-bottom'],
          popUpCTAWrapper: ['flex-col'],
          gotItCTA: ['w-full'],
        },
        desktop: {
          deleteWrapper: ['pr-0', 'mb-0'],
          popUpCTAs: ['!px-desk-component-button-full-padding-x', 'max-w-none', 'w-fit'],
          deleteInfo: ['gap-desk-margin-tight-bottom'],
          popUpCTAWrapper: ['flex-row'],
          gotItCTA: ['w-fit'],
        },
      },
    },
  },
  {
    responsiveVariants: ['md'],
  }
);
export default deleteAccount;
